export const API = process.env.VUE_APP_API;
export const GA = process.env.VUE_APP_GA;
export const STRIPE_PUBLIC = process.env.VUE_APP_STRIPE_PUBLIC;
export const PLAID_PUBLIC_KEY = process.env.VUE_APP_PLAID_PUBLIC_KEY;
export const PLAID_ENV = process.env.VUE_APP_PLAID_ENV;
// export const PLAID_PRODUCTS = process.env.VUE_APP_PLAID_PRODUCTS;
